import React from 'react'

const pt_br = {
    values: {
        'Click to add note': 'Clique para anotar',
        'ADD NOTE': 'NOVA NOTA',
        NOTE: 'NOTA',
        Note: 'Nota',
        NOTES: 'NOTAS',
        BACK: 'VOLTAR',
        'BACK TO NOTES LIST': 'VOLTAR PARA A LISTA DE NOTAS',
        'added a note': 'adicionou uma nota',
        From: 'De',
        To: 'Até',
        optional: 'opcional',
        'New note': 'Nova nota',
        'Note saved successfully': 'Nota salva com sucesso',
        'Annotated range': 'Intervalo anotado',
        'Annotated time': 'Horário anotado',
        'Timeline disabled on this dashboard': 'A Timeline está desativada neste dashboard',
        'Toggle Timeline on': 'Exibir Timeline',
        'Toggle Timeline off': 'Ocultar Timeline',
        'The end date must be after the start date': 'A data de término deve ser posterior à data de início',
        'Invalid end date': 'Data de término inválida',
        'The final value must be greater than the initial value': 'O valor final deve ser valor maior que o inicial',
        'Invalid from date': 'Data de início inválida',
        'Timeline options': 'Opções da timeline',
        'Enable timeline': 'Ativar timeline',
        'Filter timeline annotations': 'Filtrar anotações da timeline',
        'Timeline format': 'Formato',
        Temporal: 'Temporal',
        Numeric: 'Numérica',
        'Are you sure you want to delete this note': 'Tem certeza que quer excluir esta nota?',
        by: 'por',
        on: 'em',
        'Add Note': 'Nova Nota',
        CREATE: 'CRIAR',
        'This is a required field.': 'Este campo é obrigatório.',
        'Note text': 'Texto da nota',
        'Nothing found here.': 'Nada encontrado aqui.',
        'Note successfully deleted': 'Nota excluída com sucesso',
        'CREATE NOTE': 'CRIAR NOTA',
        'EDIT NOTE': 'EDITAR NOTA',
        'Note successfully exported': 'Nota foi exportada com sucesso',
        'Note failed to be exported': 'A exportação da nota falhou',
        Begin: 'Começo',
        Hour: 'Hora',
        'Marker date': 'Data do marcador',
        'Edit note text': 'Editar texto da nota',
        'EDIT MARKER': 'EDITAR MARCADOR',
        'CREATE MARKER': 'CRIAR MARCADOR',
        'Take notes on this marker': 'Faça anotações neste marcador',
        MARKERS: 'MARCADORES',
        'Marker tool': 'Marcadores',
        'Update marker': 'Atualizar marcador',
        'Delete marker': 'Remover marcador',
        Marker: 'Marcador',
        marker_widget_action_msg: (
            <React.Fragment>
                <div className="bulb-icon">
                    <i className="far fa-lightbulb-on" />
                </div>
                <div className="msg">
                    Para criar um marcador, arraste o mouse pelo gráfico selecionado e clique no ponto escolhido. Você
                    pode cancelar a qualquer momento pressionando a <br /> tecla ESC.<br />
                    <b>
                        Você também pode habilitar o marcador pressionando o atalho ALT + Clique para criar um marcador
                        neste gráfico ou SHIFT + Clique para para criar um marcador em todos os gráficos.
                    </b>
                </div>
            </React.Fragment>
        ),
        marker_widget_action_msg_2: (
            <React.Fragment>
                <div className="bulb-icon">
                    <i className="far fa-lightbulb-on" />
                </div>
                <div className="msg">
                    Para criar um marcador, arraste o mouse pelo gráfico selecionado e clique no ponto escolhido.
                </div>
            </React.Fragment>
        ),
        marker_widget_action_msg_3:
            'Tem certeza que quer excluir este marcador? A nota relacionada a este marcador também será excluida',
        'No note text': 'Sem texto',
        'Marker behavior': 'Configuração dos marcadores',
        'Current plot values': 'Valores atuais',
        'The marker displays the current curves and values seem on the chart for the given timestamp':
            'O marcador sempre mostra os valores e curvas atuais visto no gráfico',
        'Original marked values': 'Valores originais',
        'Displays the original curves and values of when the marker was first created':
            'O marcador sempre mostra os valores originais do momento de sua criação',
        'Annotations settings': 'Configuração da anotação',
        'There was an error saving the query params': 'Houve um erro ao salvar os parâmetro das consultas',
        'Query params': 'Parâmetros das consultas',
        extend_history_help_block: ({ pipesVersion }) => {
            return <>"Extend history" é um "período" da linguage Pipes. Verifique <a target="_blank" href={`https://pipes.intelie.com/docs/${pipesVersion}/#timespan-period`}>documentação</a>. </>
        }
    }
}

module.exports = pt_br
